import React from "react";
import { doctorProfileFiles } from "../../../../Util/API Calls/APIList";
import Unselect from "../../../../assets/Unselect.svg";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  top: 4,
  left: 0,
  cursor: "pointer",
}));

const SelectedDoctorsNew = ({
  id,
  initials,
  name,
  removeSelectedDoctors,
  dr_first_name,
  profile_picture_url,
  selected,
}) => {
  return (
    <div>
      <div style={{ display: "flex" }}>
        <div className={profile_picture_url !== "" ? "pp" : "no-pp"}>
          {profile_picture_url !== "" ? (
            <img
              className={profile_picture_url !== "" ? "pp" : "no-pp"}
              src={profile_picture_url}
              alt=""
            />
          ) : (
            <p className="m-0">{dr_first_name?.charAt(0)}</p>
          )}
        </div>
        <div className="close-icn">
          <img
            src={Unselect}
            alt=""
            onClick={() => removeSelectedDoctors(id)}
          />
        </div>
      </div>
      <div className="text-center">
        <small>{"Dr. " + dr_first_name}</small>
      </div>
    </div>
  );
};

export default SelectedDoctorsNew;
